<template>
  <div class="menus">
    <a-menu v-model:selectedKeys="selectedKeys" v-model:openKeys="openKeys" mode="inline" theme="dark"
      @select="handleSelect">
      <template v-for="v in list" :key="v.name">
        <template v-if="v.children && v.children.length > 0">
          <a-sub-menu :key="v.name">
            <template #icon><icon-font :type="v?.meta?.icon as string" /></template>
            <template #title>{{ v?.meta?.title }}</template>
            <template v-for="vv in v.children" :key="vv.name">
              <template v-if="!vv?.meta?.isHidden">
                <a-menu-item :key="vv.name">
                  <router-link :to="vv.path">
                    {{ vv?.meta?.title }}
                  </router-link>
                </a-menu-item>
              </template>
            </template>
          </a-sub-menu>
        </template>
      </template>
    </a-menu>
  </div>
</template>
<script lang="ts" setup>
import { useUserStore } from '@/store'
import { ref, watch } from 'vue'
import IconFont from './IconFont.jsx'
import { useRoute } from 'vue-router'
import { hasHiddenChildren } from '@/configs/route.config'

const userStore = useUserStore()
const route = useRoute()

const list = userStore.roleRouters[0].children

const selectedKeys = ref<string[]>([])
const openKeys = ref<string[]>([])

const handleSelect = (e: unknown) => {
  console.log(e)
}

const updateRoute = () => {
  const { name, matched, meta } = route
  openKeys.value = []

  if (meta.isHidden) {
    selectedKeys.value = [`${meta.parent as string}`]
  } else {
    selectedKeys.value = [`${name as string}`]
  }

  const keys: string[] = []
  matched.filter(e => e.name !== name).forEach(e => {
    keys.push(e.name as string)
  })

  openKeys.value = keys

  if (keys.filter(e => hasHiddenChildren.includes(e)).length > 0) {
    selectedKeys.value = keys
  }
}

watch(route, () => {
  // console.log('路由变化', e)
  updateRoute()
}, { immediate: true })
</script>

<style lang="less" scoped>
.menus {
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  padding: 20px 0;

  &::-webkit-scrollbar {
    width: 0;
  }
}
</style>
